import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RoleplayService, StepperContent } from '../../../service/roleplay/roleplay.service';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { Subscription } from 'rxjs';
import { RoleplayStep1Component } from '../roleplay-step1/roleplay-step1.component';


interface options {
  value: boolean,
  name: string
}

@Component({
    selector: 'app-roleplay-container',
    templateUrl: './roleplay-container.component.html',
    styleUrls: ['./roleplay-container.component.scss', '../../../../assets/css/roleplay.scss'],
    standalone: false
})

export class RoleplayContainerComponent implements OnInit {

  @ViewChild(RoleplayStep1Component) RoleplayStep1Component!: RoleplayStep1Component;
  step1Form: FormGroup;
  sharedData: any = {};
  subscription: Subscription;
  currentStepper: number = 1;
  submittedValueCareer: any = [];
  submittedValueFamily: any = [];
  submittedValueProfession: any = [];
  subscriptionCareer: Subscription;
  subscriptionFamily: Subscription;
  subscriptionProfession: Subscription;
  isEditMode: boolean = false;

  metaData: any[] = [];

  constructor(private route: ActivatedRoute, public Router: Router, private fb: FormBuilder, private sharedService: RoleplayService) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.isEditMode = true;
        this.sharedService.setEditMode(true);
        this.loadItem(id);
      } else {
        this.isEditMode = false;
        this.sharedService.setEditMode(false);
      }
    });

    this.step1Form = this.fb.group({
      customerName: ['DR. Lucy Smith', Validators.required],
      age: ['45 Yrs', Validators.required],
      occupation: ['Neuro', Validators.required],
    });

    this.sharedService.changeStepper({ current: 1, type: 'I' });
    this.subscription = this.sharedService.stepperData.subscribe((results) => {
      this.currentStepper = results.current;
    });
  }

  loadItem(id: string): void {
    this.sharedService.fetchData(id);
    this.sharedService.data$.subscribe({
      next: data => {
        this.metaData = data;
      },
      error: error => console.error('Error receiving data', error),
      complete: () => {

      }
    });
  }

  updateSelectedSection(optionIndex: number, optionId: string, event: Event, sectionArray: any, formControlName: string) {
    const isChecked = (event.target as HTMLInputElement).checked;
    sectionArray[optionIndex].checked = isChecked;
  }
  skipToChat() {
    this.Router.navigate(['/app-abiomed-chat', { mode: 'roleplay' }], { skipLocationChange: true });
  }
  ngOnDestroy() {
    this.sharedService.clearSelectedData();
  }

  goToStep(id: number) {
    const stepper_data: StepperContent = this.sharedService.stepperContent.find(stepper => stepper.stepId == id);
    this.RoleplayStep1Component.changeStepper(stepper_data);
  }

  next() {
    if (this.currentStepper < 4) {
      const next_step_id: number = this.currentStepper + 1;
      this.goToStep(next_step_id)
    } else {
      this.Router.navigate(['/app-abiomed-chat', { mode: 'roleplay' }], { skipLocationChange: true });
    }
  }
}
